import React from 'react';
import { ReactComponent as CardDownload } from '../../../assets/icons/card-download.svg';
import { ReactComponent as CardGroupDownload } from '../../../assets/icons/card-group-download.svg';
import { useStyles } from './Download.styles';
import { IconButton, SvgIcon } from '@material-ui/core';
import TooltipOne from '../../TooltipOne/TooltipOne.component';
import { ExamTaskGroupSolutionStatus, ExamTaskGroupSolutionStatusDisablingDownloading } from '../../../services/exams/assessmentSession/assessments.types';
import CancelIcon from '@material-ui/icons/Cancel';
import { fill } from '../../../utils/contrastSvgAttributes';

interface DownloadProps {
  status: ExamTaskGroupSolutionStatus;
  handleCardDownload: () => void;
  handleCardGroupDownload: () => void;
}

export const Download: React.FC<DownloadProps> = ({ status, handleCardDownload, handleCardGroupDownload }) => {
  const classes = useStyles();

  const buildDownloadButton = (isSingleCard: boolean): JSX.Element => {
    const tooltipText = () => {
      switch (status) {
        case ExamTaskGroupSolutionStatus.NoneExaminerBlocked:
          return 'Możliwość pobierania kart do oceny została zablokowana';
        case ExamTaskGroupSolutionStatus.NoneProcessFinished:
          return 'Aktualnie w systemie nie ma kart do pobrania';
        case ExamTaskGroupSolutionStatus.NoneSessionClosed:
          return 'Sesja ma status "Zamknięta"';
        default:
          return isSingleCard ? 'Pobierz pojedynczą kartę' : 'Pobierz wszystkie karty do limitu';
      }
    };
    const isDisabled = ExamTaskGroupSolutionStatusDisablingDownloading.includes(status);
    return (
      <TooltipOne title={tooltipText()} placement="top">
        <div>
          <IconButton
            disableRipple={isDisabled}
            size="small"
            disabled={isDisabled}
            className={classes.cardDownloadIcon}
            onClick={isSingleCard ? handleCardDownload : handleCardGroupDownload}
            aria-label="ikona pobierz karty do limitu"
          >
            {isDisabled ? (<CancelIcon className={classes.disabledAction} />) : <></>}
            {isSingleCard ? (
              <SvgIcon className={classes.onHover} aria-label="ikona pobierz kartę">
                <CardDownload className={classes.filledIcon} style={{ width: '35px', height: '35px' }} />
              </SvgIcon>
            ) : (
              <SvgIcon className={classes.onHover} aria-label="ikona pobierz karty do limitu">
                <CardGroupDownload className={classes.filledIcon} />
              </SvgIcon>
            )}
          </IconButton>
        </div>
      </TooltipOne>
    );
  };

  return (
    <div className={classes.container}>
      {buildDownloadButton(true)}
      {buildDownloadButton(false)}
    </div>
  );
};
